import React from 'react';
import { Bell, Plus, CheckCircle } from 'lucide-react';

const NotificationManager = ({
  notifications,
  setShowAddNotificationModal,
  setShowEditNotificationModal,
  setEditingNotification,
  deleteNotification,
  applyNotificationToAll
}) => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
          <div>
            <h1 className="text-xl md:text-2xl font-bold mb-1">Notification Settings</h1>
            <p className="text-xs md:text-sm text-gray-400">Configure notification channels for SSL certificate alerts</p>
          </div>
          <button
            onClick={() => setShowAddNotificationModal(true)}
            className="flex items-center gap-2 px-3 py-1.5 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition-colors font-medium text-sm"
          >
            <Plus className="w-4 h-4" />
            <span className="hidden sm:inline">Add Notification</span>
            <span className="sm:hidden">Add</span>
          </button>
        </div>

        {/* Notification Cards */}
        <div className="grid gap-3">
          {notifications.length === 0 ? (
            <div className="bg-gray-900 rounded-lg border border-gray-800 p-6 text-center text-gray-500 text-sm">
              No notifications configured yet. Add one below.
            </div>
          ) : (
            notifications.map((notification) => (
              <div key={notification.id} className="bg-gray-900 rounded-lg border border-gray-800 p-4">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-500/20 rounded-lg flex items-center justify-center">
                      <Bell className="w-5 h-5 md:w-6 md:h-6 text-blue-400" />
                    </div>
                    <div>
                      <h3 className="text-base md:text-lg font-semibold">{notification.name}</h3>
                      <p className="text-xs md:text-sm text-gray-400 capitalize">{notification.type}</p>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button 
                      onClick={() => applyNotificationToAll(notification.id)}
                      className="px-3 py-1 bg-green-500/20 text-green-400 rounded hover:bg-green-500/30 transition-colors text-xs md:text-sm flex items-center gap-1"
                      title="Apply this notification to all certificates"
                    >
                      <CheckCircle className="w-3 h-3 md:w-4 md:h-4" />
                      Apply to All
                    </button>
                    <button 
                      onClick={() => {
                        setEditingNotification(notification);
                        setShowEditNotificationModal(true);
                      }}
                      className="px-3 py-1 bg-gray-800 text-white rounded hover:bg-gray-700 transition-colors text-xs md:text-sm"
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => deleteNotification(notification.id)}
                      className="px-3 py-1 bg-red-500/20 text-red-400 rounded hover:bg-red-500/30 transition-colors text-xs md:text-sm"
                    >
                      Delete
                    </button>
                  </div>
                </div>

                <div className="space-y-3 text-xs md:text-sm">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                    <div>
                      <p className="text-gray-400 mb-1">Bot Display Name</p>
                      <p className="text-white">{notification.bot_name}</p>
                    </div>
                    <div>
                      <p className="text-gray-400 mb-1">Prefix Custom Message</p>
                      <p className="text-white">{notification.prefix_message || 'None'}</p>
                    </div>
                    <div>
                      <p className="text-gray-400 mb-1">Resend Interval</p>
                      <p className="text-white">Every {notification.resend_times || 2} {(notification.resend_times || 2) === 1 ? 'check' : 'checks'}</p>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center gap-3 md:gap-4 pt-3 border-t border-gray-800">
                    <label className="flex items-center gap-2 text-gray-300">
                      <input
                        type="checkbox"
                        checked={notification.default_enabled === 1}
                        className="w-3 h-3 md:w-4 md:h-4 rounded"
                        readOnly
                      />
                      Default enabled
                    </label>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationManager;
